import { createSelector } from '@reduxjs/toolkit';
import { currentEmployeeAsViewModel } from './current-employee-as-view-model';

import { getOrganization } from '../organization/getOrganization';

export const currentUserIsOwner = createSelector(
  currentEmployeeAsViewModel,
  getOrganization,
  function (currentEmployee, organization) {
    if (currentEmployee && currentEmployee.email && organization && organization.ownerEmail) {
      return (currentEmployee.email.toUpperCase() || '') === organization.ownerEmail.toUpperCase();
    }
    return false;
  },
);
